import styled from 'styled-components';

type DropdownOptionProps = {
  forExtendedDropdown?: boolean;
};
export const DropdownOption = styled.div.attrs<DropdownOptionsProps>({
  'data-testid': 'dropdown-option',
})<DropdownOptionsProps>`
  position: relative;
  z-index: 100;
  background-color: white;
  width: 100%;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  overflow: hidden;
`;

type DropdownOptionsProps = DropdownOptionProps & {
  striped?: boolean;
  searchable?: boolean;
};

export const DropdownOptions = styled(DropdownOption).attrs<DropdownOptionsProps>({
  'data-testid': 'dropdown-options',
})<DropdownOptionsProps>`
  & .form-check:hover {
    background-color: ${(props) => props.theme.palette.darkGray}!important;
    color: white !important;
  }
  & .form-check:hover span {
    color: white;
  }
  & > .form-check:nth-child(odd) {
    ${(props) => props.striped && `background-color: ${props.theme.palette.gray}`};
  }
`;
